import React from 'react';
import {Spinner} from '@goproblems/ui';

export const Loading = ({
    text,
    className,
}: {
    text?: string;
    className?: string;
}) => (
    <div className={`flex flex-col items-center ${className}`}>
        <Spinner />
        {text && <div className="mt-2 text-lg font-semibold">{text}</div>}
    </div>
);
